import type { CommandBody } from '../CrossOriginMessage';

/**
 * Indicates the access token of view.
 */
export class GetViewTokenCommandBody implements CommandBody {
  /**
   * View Id.
   */
  viewId: string;
}
